<template>
     <div style="width:1300px;margin:0 auto;background:#999;">
            <!-- <div class="card mb-5 p-2" style="box-shadow: 10px 10px 5px #888888;margin-top:50px;background:url(../../static/images/rizi1.jpg) no-repeat;
            background-size:cover;
            height:1000px;"> -->
            <div v-show="showVue" class="card mb-5 p-2" style="box-shadow: 10px 10px 5px #888888;margin-top:100px;">
                <p class="text-center mb-2">
                      <span class="float-right span_close" style="display:block;width:20px;line-height:20px;text-align:center;font-size:25px;" @click="$router.go(-1)">
                           &times;
                      </span>
                </p>
               
                   
                               <div>
                                      <div class="yulan_k">
                                             <!-- <span>
                                                  浏览人:
                                             </span>
                                             <span>
                                                  {{item.truename}}
                                             </span> -->
                                              <span class="ml-1">
                                                 浏览次数:
                                            </span>
                                            <span style="font-size:17px;font-weight:bold;color:red;">
                                                 {{totalSumAll}}
                                            </span> 
                                            <!-- <span class="ml-5">
                                                 {{item.inserttime}}
                                            </span> -->
                                      </div>
                                       <div class="zd_k">
                                              <div class="mt-2" v-if="groupid==66">
                                                  <button v-if="topIndex==0" class="zhiding">置顶</button>
                                                  <button v-else class="quxiaozd">取消置顶</button>
                                             </div>
                                             <div class="mt-2" v-else>
                                                 <button v-if="topIndex==0" class="zhiding">置顶</button>
                                            </div>
                                       </div>
                                       
                                                            <div>
                                                                 <p class="text-right">
                                                                      <button class="btn btn-primary" @click="revert()">
                                                                           回复
                                                                      </button>
                                                                 </p>
                                                            </div>

                                          


                                    
                                    
                                   
                                      <h4 class="text-center header_title">
                                         
                                           <span> 
                                                 {{title}}
                                           </span>
                                          
                                      </h4>
                                       <!-- <p class="text-right">
                                            <button v-if="iscollect" class="btn btn-danger" @click="quxiao()">
                                                  <span>
                                                       取消收藏
                                                  </span>
                                            </button>
                                            <button v-else class="btn btn-primary" @click="shouchang()">
                                                  <span>
                                                    收藏帖子
                                                  </span>
                                            </button>
                                       </p> -->
                                                  <div class="body_content">
                                                       <section v-html="content" class="mt-2" style="font-size:20px;text-indent:40px;line-height:50px;">
                                                                 {{content}}
                                                       </section>
                                                           
                                                            <div class="mt-5">
                                                                 <!-- <p>
                                                                      <span>
                                                                           图片:
                                                                      </span>
                                                                 </p> -->
                                                                 <!-- <div class="image_content">
                                                                      <div class="mt-2" v-for="(item,index) in imgData" :key="index">
                                                                                <img v-image-preview class="Image mr-1 limg"  :src="'http://fw.hyey.cn'+item" alt="">
                                                                      </div>
                                                                 </div> -->
                                                                 <div class="image_content">
                                                                      <viewer class="mt-2" :images="imgData"   v-for="(item,index) in imgData"  :key="index"> 
                                                                                <img v-if="item!==''" class="Image mr-1 limg"
                                                                                     :src="'http://fw.hyey.cn'+item"
                                                                                     alt=""
                                                                                >
                                                                      </viewer>
                                                                 </div>
                                                                 <div v-if="fileurl[0]!=null&&fileurl[0]!=''" class="mt-4 fj_c">
                                                                      <span style="color:red;">
                                                                        附件:
                                                                      </span>
                                                                       <div>
                                                                             <table style="width:500px;">
                                                                                  <!-- <tr class="text-center">
                                                                                       <th>文件名</th>
                                                                                        <th>操作</th>
                                                                                  </tr> -->
                                                                                  <tr class="text-center" v-for="(item,index) in fileurl" :key="index">
                                                                                       <td v-if="item!=''" style="color:blue;line-height:30px;">
                                                                                            <a>
                                                                                              {{item | handler}}
                                                                                            </a>
                                                                                       </td>
                                                                                       <td v-if="item!=''">
                                                                                            <button class="bg-primary button_zi heit" @click="upload(item)">
                                                                                                 下载
                                                                                            </button>
                                                                                       </td>
                                                                                  </tr>
                                                                             </table>
                                                                       </div>
                                                                 </div>
                                                            </div>

                                                            <div  v-if="showHF">

                                                                    
                                                            <div class="mt-2">
                                                                  <p class="text-right">
                                                                          <button class="qbhf_btn" @click="qubuhf()">
                                                                            全部回复
                                                                          </button>
                                                                        <button class="ywxg_btn ml-3" @click="ywxg()">
                                                                            与我相关
                                                                         </button>
                                                                  </p>
                                                              
                                                            </div>
                                             <!-- 回复的内容 -->
                                                            <div v-if="showHuifu" class="xhf_c_c">
                                                                 <div v-for="(item,index) in huifu" :key="index">
                                                                          <div class="xhf_c">
                                                                              <!-- <div v-if="item.replyid!==-1">
                                                                                   <span style="color:#2daebf;font-weight:700;">
                                                                                        引用:
                                                                                   </span>
                                                                                   <p v-html="item.replyed" class="ml-5">
                                                                                        {{item.replyed}}
                                                                                   </p> 
                                                                              </div> -->
                                                                               <div class="ziti_t">
                                                                                    <p class="ml-2" style="color:#36d;font-weight:600;">
                                                                                           {{item.replytruename | jiequ}}

                                                                                       

                                                                                    </p> 
                                                                                  
                                                                               </div>   
                                                                                    <p class="text-right mr-2" style="font-size:15px;color:#ff9812;font-weight:500;" v-if="item.replytruename==author">
                                                                                             楼主
                                                                                    </p>
                                                                                         
                                                                                     <div class="row m-0"> 
                                                                                            
                                                                                               <div style="color:#999;" class="col-3 text-center hf_c_left1">
                                                                                                      
                                                                                                    <div class="rname mg_n" v-if="item.replyid==-1">
                                                                                                          <span class="name_f">
                                                                                                             {{item.replytruename}}
                                                                                                          </span>
                                                                                                    </div>
                                                                                                     <div class="rname ml-3" v-if="item.replyid!==-1">
                                                                                                          <span class="name_f">
                                                                                                             {{item.replytruename}}
                                                                                                          </span>
                                                                                                              <span>
                                                                                                                   @
                                                                                                              </span> 
                                                                                                          {{item.replytruenameed}}
                                                                                                          <p v-html="item.replyed" class="mt-3 hf_content">
                                                                                                             
                                                                                                               
                                                                                                            
                                                                                                              
                                                                                                          </p>
                                                                                                     </div>
                                                                                               </div>

                                                                                               <div class="hj_c_right col-9 p-0 mt-5"> 
                                                                                                 <div v-html="item.reply" style="font-size:15px;">
      
                                                                                                  </div>
                                                                                                 <div class="mt-4">
                                                                                                              <div class="image_content">
                                                                                                                   <viewer class="mt-2">  
                                                                                                                                       <img v-if="item.image1!=''" class="Image mr-2 limg2"
                                                                                                                                            :src="'http://fw.hyey.cn'+item.image1"
                                                                                                                                            alt=""
                                                                                                                                       >
                                                                                                                                       
                                                                                                                                       <img v-if="item.image2!=''" class="Image mr-2 limg2"
                                                                                                                                            :src="'http://fw.hyey.cn'+item.image2"
                                                                                                                                            alt=""
                                                                                                                                       >
                                                                                                                                       
                                                                                                                                       <img v-if="item.image3!=''" class="Image mr-2 limg2"
                                                                                                                                            :src="'http://fw.hyey.cn'+item.image3"
                                                                                                                                            alt=""
                                                                                                                                       >
                                                                                                                                       
                                                                                                                                       <img v-if="item.image4!=''" class="Image mr-2 limg2"
                                                                                                                                            :src="'http://fw.hyey.cn'+item.image4"
                                                                                                                                            alt=""
                                                                                                                                       >
                                                                                                                                       
                                                                                                                                       <img v-if="item.image5!=''" class="Image mr-2 limg2"
                                                                                                                                            :src="'http://fw.hyey.cn'+item.image5"
                                                                                                                                            alt=""
                                                                                                                                       >
                                                                                                                   </viewer>
                                                                                                              </div>
                                                                                                     </div>
                                                                                                     <div v-if="item.fileurl[0]!=null&&item.fileurl[0]!=''" class="mt-4 mb-4">
                                                                                                              <span style="color:red;">
                                                                                                              附件:
                                                                                                              </span>
                                                                                                              <div>
                                                                                                                   <table style="width:500px;">
                                                                                                                        <!-- <tr class="text-center">
                                                                                                                             <th>文件名</th>
                                                                                                                             <th>操作</th>
                                                                                                                        </tr> -->
                                                                                                                        <tr class="text-center" v-for="(item1,index1) in item.fileurl" :key="index1">
                                                                                                                             <td v-if="item1!=''" style="color:blue;line-height:30px;">
                                                                                                                                  <a>
                                                                                                                                  {{item1 | handler}}
                                                                                                                                  </a>
                                                                                                                             </td>
                                                                                                                             <td v-if="item1!=''">
                                                                                                                                  <button class="bg-primary button_zi heit" @click="upload(item1)">
                                                                                                                                       下载
                                                                                                                                  </button>
                                                                                                                             </td>
                                                                                                                        </tr>
                                                                                                                   </table>
                                                                                                              </div>
                                                                                                         </div>
                                                                                               </div>
                                                                                 
                                                                                              

                                                                                     </div>
                                                                                      
                                                                                   
                                                                                    <p class="mt-2 text-right">
                                                                                          <span style="color:#c9b4ac">
                                                                                             {{item.inserttime}}
                                                                                         </span>
                                                                                         <span id="green_channel">

                                                                                               <a id="green_channel_digg" class="ml-2 mb-2" @click="minrevert(item.id,item.replyid,item.replayfid)">
                                                                                                    回复
                                                                                               </a>
                                                                                         </span>
                                                                                    </p>








                                                                                                                        
                                                                       <div class="qbxf_c">  
                                                                                       


                                                                       <p style="margin-bottom:30px;" v-if="item.showXHF">
                                                                            <a class="ml-5 mt-3 qb_hf hf_show" @click="showqbhf(index)">
                                                                                  全部评论回复
                                                                                  <span>
                                                                                    ({{item.child.length}})
                                                                                  </span>
                                                                                  
                                                                            </a>
                                                                       </p> 

                                                                                <div v-show="item.showqbhf">


                                                                                             <div class="xhf_p showqbhf" v-for="(child,index) in item.child" :key="index">
                                                                              <!-- <div v-if="item.replyid!==-1">
                                                                                   <span style="color:#2daebf;font-weight:700;">
                                                                                        引用:
                                                                                   </span>
                                                                                   <p v-html="item.replyed" class="ml-5">
                                                                                        {{item.replyed}}
                                                                                   </p> 
                                                                              </div> -->
                                                                               <!-- <div class="ziti_t">
                                                                                    <p class="ml-2" style="color:#36d;font-weight:600;">
                                                                                           {{child.replytruename | jiequ}}

                                                                                       
  
                                                                                    </p> 
                                                                                  
                                                                               </div>    -->
                                                                                    <p class="mr-2" style="font-size:15px;color:#ff9812;font-weight:500;float:right;" v-if="child.replytruename==author">
                                                                                             楼主
                                                                                    </p>
                                                                                   
                                                                                         
                                                                                     <div> 
                                                                                            
                                                                                               <div style="color:#999;" class=" text-center hf_c_left">
                                                                                                      
                                                                                                    <div class="rname mg_n" v-if="child.replyid==-1">
                                                                                                          <span class="name_f">
                                                                                                             {{item.replytruename}}
                                                                                                          </span>
                                                                                                    </div>
                                                                                                     <div class="rname mg_n" v-if="child.replyid!==-1">
                                                                                                          
                                                                                                          <span class="name_f">
                                                                                                             {{child.replytruename}}
                                                                                                          </span>
                                                                                                              <span>
                                                                                                                   @
                                                                                                              </span> 
                                                                                                          {{child.replytruenameed}}
                                                                                                          <p v-html="child.replyed" class="mt-3 hf_content">
                                                                                                             
                                                                                                               
                                                                                                            
                                                                                                              
                                                                                                          </p>
                                                                                                     </div>
                                                                                               </div>

                                                                                              
                                                                                 
                                                                                              

                                                                                     </div>

 
                                                                                     <div style="margin-left:100px;margin-top:100px;">
                                                                                                          <div class="hj_c_right mt-5">
                                                                                                    <div class="hj_c_right_c">

                                                                                                    <div v-html="child.reply" class="right_cp">
  
                                                                                                  </div>
                                                                                                 <div class="mt-4">
                                                                                                              <div class="image_content">
                                                                                                                   <viewer class="mt-2">  
                                                                                                                                       <img v-if="child.image1!=''" class="Image mr-2 limg2"
                                                                                                                                            :src="'http://fw.hyey.cn'+child.image1"
                                                                                                                                            alt=""
                                                                                                                                       >
                                                                                                                                       
                                                                                                                                       <img v-if="child.image2!=''" class="Image mr-2 limg2"
                                                                                                                                            :src="'http://fw.hyey.cn'+child.image2"
                                                                                                                                            alt=""
                                                                                                                                       >
                                                                                                                                       
                                                                                                                                       <img v-if="child.image3!=''" class="Image mr-2 limg2"
                                                                                                                                            :src="'http://fw.hyey.cn'+child.image3"
                                                                                                                                            alt=""
                                                                                                                                       >
                                                                                                                                       
                                                                                                                                       <img v-if="child.image4!=''" class="Image mr-2 limg2"
                                                                                                                                            :src="'http://fw.hyey.cn'+child.image4"
                                                                                                                                            alt=""
                                                                                                                                       >
                                                                                                                                       
                                                                                                                                       <img v-if="child.image5!=''" class="Image mr-2 limg2"
                                                                                                                                            :src="'http://fw.hyey.cn'+child.image5"
                                                                                                                                            alt=""
                                                                                                                                       >
                                                                                                                   </viewer>
                                                                                                              </div>
                                                                                                     </div>
                                                                                                     <div v-if="child.fileurl[0]!=null&&child.fileurl[0]!=''" class="mt-4 mb-4">
                                                                                                              <span style="color:red;">
                                                                                                              附件:
                                                                                                              </span>
                                                                                                              <div>
                                                                                                                   <table style="width:500px;">
                                                                                                                        <!-- <tr class="text-center">
                                                                                                                             <th>文件名</th>
                                                                                                                             <th>操作</th>
                                                                                                                        </tr> -->
                                                                                                                        <tr class="text-center" v-for="(item1,index1) in child.fileurl" :key="index1">
                                                                                                                             <td v-if="item1!=''" style="color:blue;line-height:30px;">
                                                                                                                                  <a>
                                                                                                                                  {{item1 | handler}}
                                                                                                                                  </a>
                                                                                                                             </td>
                                                                                                                             <td v-if="item1!=''">
                                                                                                                                  <button class="bg-primary button_zi heit" @click="upload(item1)">
                                                                                                                                       下载
                                                                                                                                  </button>
                                                                                                                             </td>
                                                                                                                        </tr>
                                                                                                                   </table>
                                                                                                              </div>
                                                                                                         </div>
 


                                                                                                         
                                                                                                    </div> 
                                                                                             
                                                                                               </div>
                                                                                          </div>
                                                                                      
                                                                                   
                                                                                    <p class="mt-2 text-right" style="margin-right:60px;">
                                                                                          <span style="color:#c9b4ac">
                                                                                             {{child.inserttime}}
                                                                                         </span>
                                                                                         <span id="green_channel">

                                                                                               <a id="green_channel_digg" class="ml-2 mb-2" @click="minrevert(child.id,child.replyid,child.replyfid)">
                                                                                                     回复
                                                                                               </a>
                                                                                         </span>
                                                                                    </p>



                                                                                              </div>

 

                                                                                           
                   

                                                                                </div>

                                                                               

   
                                                                       </div>
                                                                 

                                                               
    

                                                              


                                                        


                                                                          



                                                                     
                                                                       </div> 


                                                                           <!-- 评论信息 -->
                                                                                  
                                                                           
                                                                      





                                                             
                                                                 </div>
                                                            </div>


                                                             <div class="mt-5">
                                                                 <v-pagination :total="total" :current-page='current' @pagechange="pagechange"></v-pagination>
                                                            </div>

                                                                 
                                                            </div>





                                                  </div>
                                                  
                                       <p class="footer_author">
                                            <span>
                                                 作者:
                                            </span>
                                            <span style="color:green;">
                                                 {{author}}
                                            </span>
                                       </p>
                               </div>
                               <!-- <div class="activities_details" v-if="isChoose">
                                    <div class="active_autoimg">
                                      <img class="active_img" :src="showimg" alt="">
                                    </div>
                                    <svg width="60" height="60" class="close_activities" @click.stop="showActivitiesFun">
                                        <circle cx="30" cy="30" r="25" stroke="#555" stroke-width="1" fill="none"/>
                                        <line x1="22" y1="38" x2="38" y2="22" style="stroke:#999;stroke-width:2"/>
                                        <line x1="22" y1="22" x2="38" y2="38" style="stroke:#999;stroke-width:2"/>
                                   </svg>
                               </div> -->
                                                         
            </div>
     </div>
</template>
<script>
import {mapState} from 'vuex'
import Vue from "vue"
import vPagination from "../../components/Pagination.vue";
export default {
     data(){
          return{
              lxs:'',
              state:'',
              pageIndex:'',
              id:'',
              title:"",
              content:'',
              author:'',
              isChoose:false,
              yulan:[],
              imgData:[],
              imgData1:[],
              showActive:false,
              showimg:'',
              huifu:[],
              showHuifu:false,
              fileurl:[],
              iscollect:"",
              showVue:false,
              iscollectid:"",
              groupid:window.sessionStorage.getItem("groupid"),
              topIndex:"",
              hfid:"",
              showimage:false,
              showHF:false,
              user:"",
              activeIndex:-1,
              totalSumAll:0,

               total:1,     // 记录总条数
            display: 20,   // 每页显示条数
            current: 1,   // 当前的页数
          }
      },
   computed:{
       ...mapState([
            'imgUrl',
       ]),
   },
    components:{
           vPagination,
      },
    filters:{
           handler(value){
             let wenjian=value.split("/")
            return wenjian[wenjian.length-1]
             
          },
             jiequ:function(a){
             return a.substring(0,1)
        }
        },
      methods:{

           quxiao:async function(){
            const { data: res } = await this.$http.post('Dls/getFun', {
            action: 'ClerkUpBlog',
          obj: JSON.stringify({ 
                lxs:'8',
                id:this.iscollectid,
          })
        })

            if(res.isok){
                 if(res.data.isok){

                      alert(res.data.msg)
                      this.lookBlog();

                 }
            }
            else{
                 alert(res.message)
            }

          },


          shouchang:async function(){
            const { data: res } = await this.$http.post('Dls/getFun', {
            action: 'ClerkUpBlog',
          obj: JSON.stringify({ 
                lxs:'7',
                id:this.id,
          })
        })

            if(res.isok){
                 if(res.data.isok){
                      alert(res.data.msg)
                      this.lookBlog();
                 }
            }
            else{
                 alert(res.message)
            }

          },

           upload(item){
                
               window.location.href = 'http://fw.hyey.cn'+item;

           },
               
            showActivitiesFun:function (index,item) {  
                this.showimg='http://fw.hyey.cn'+item;
                this.isChoose = !this.isChoose  
            },
       //查看日志
       lookBlog:async function(){
              // this.getNowTime()
            const { data: res } = await this.$http.post('Dls/getFun', {
          action: 'ClerkLookBlog',
          obj: JSON.stringify({
                username:window.sessionStorage.getItem('username'),
                lxs:'1',
                state:'0',
                id:this.id,
          })
        })
     //     console.log(res)
        if (res.isok) { 
             if(res.data.isok){
                  this.showVue=true;
                  const obj = res.data;
                  this.iscollect =obj.iscollect;
                  this.iscollectid=obj.iscollectid;

                  this.title=obj.rows[0].title;
                  this.topIndex = obj.rows[0].topindex;
                  if(obj.rows[0].fileurl!=null){

                       this.fileurl=obj.rows[0].fileurl.split(",")
                    //    console.log(this.fileurl)
                  }
                  // console.log(this.title)
                  this.content=obj.rows[0].contents;
                  this.imgData.push(obj.rows[0].image1,obj.rows[0].image2,obj.rows[0].image3,obj.rows[0].image4,obj.rows[0].image5);
               //console.log(this.imgData)
                  this.author = obj.rows[0].truename;
                  this.yulan = obj.rows3;
                 this.yulan.map((item) => {this.totalSumAll += Number(item.count)})
               //    this.huifu = obj.rows2;
               //    this.huifu.forEach((item,index)=>{
                      
               //         if(item.fileurl!=null){

               //         item.fileurl=item.fileurl.split(",")
                   
               //    }
               //           this.imgData1[index]=[];
               //           this.imgData1[index].push(item.image1,item.image2,item.image3,item.image4,item.image5);
                      
               //    })
               // //     console.log(this.imgData1)
               //    if(this.huifu.length>0)
               //    {
               //    this.showHuifu=true;
                  
          
               //    }
               //    else{
               //         this.showHuifu=false;
               //    }
                  
             }
        }
       },


     

       //获取回复

         getReplay:async function(PageIndex){
            
            const { data: res } = await this.$http.post('Dls/getReply2', {
                PageIndex:PageIndex,
                logid:Number(this.id),
                user:this.user,
        })
          //   console.log(res)
            if(res.isok){
                 const obj = res.data
                    if(obj.length>0){
                         this.showHF=true
                    }else{
                         this.showHF=false
                    }
                   this.huifu = res.data;
                   this.record = res.record
                   this.total = res.totalCount
                   const that =this
                  that.huifu.forEach((item,index)=>{
                             
                       item.showqbhf=false
                    
                       if(item.fileurl!=null){

                       item.fileurl=item.fileurl.split(",")
                   
                  }
                       if(item.child!=null){
                            item.child.forEach((child,index)=>{
                                child.fileurl=child.fileurl.split(",")
                                if(child.replyed!==null){
                                     if(child.replyed.length>15){
                                          child.replyed=child.replyed.substr(0, 14) + "...";
                                     }
                                }
                            }) 
                            item.showXHF=true
                            if(item.child.length==0){
                                 item.showXHF=false
                            }
                       }
                       else{
                            item.showXHF=false
                       }
                       
                         that.imgData1[index]=[];
                         that.imgData1[index].push(item.image1,item.image2,item.image3,item.image4,item.image5);
                         if((item.image1==""||item.image1==null)&&(item.image2==""||item.image2==null)&&(item.image3==""||item.image3==null)&&(item.image4==""||item.image4==null)&&(item.image5==""||item.image5==null)){
                              that.showimage=false;
          
                         }
                         else{
                              that.showimage=true;
                         }
                        
                      
                  })
               //     console.log(this.imgData1)
                  if(that.huifu.length>0)
                  {
                  that.showHuifu=true;
                  
          
                  }
                  else{
                       that.showHuifu=false;
                  }
            }  
         },

    getID(){
         this.id=this.$route.query.id;
     //     console.log(this.id)
      },
//回复日志
        revert(){
            this.$router.push({path:'/revert',query:{id:this.id}})
       },
       minrevert(id,replyid,replyfid){

            this.hfid=window.sessionStorage.setItem("hfid",this.id);
            if(replyid==-1){
                 replyfid=id;
            }
            this.$router.push({path:'/minrevert',query:{id:id,replyfid:replyfid}})
       },
       //显示隐藏回复
       showqbhf(index){
          //     $(".xhf_c_c").on("click",".hf_show",function(){

          //        if($(this).hasClass("sshh")){
          //                $(this).parent().nextAll().hide();
          //             $(this).removeClass("sshh")
          //        }else{
          //                $(this).parent().nextAll().show();
          //             $(this).addClass("sshh")
          //        }

          //   });  

               this.huifu[index].showqbhf=!this.huifu[index].showqbhf;
               Vue.set(this.huifu,index,this.huifu[index])

               // console.log(this.huifu[index].showqbhf)

               // this.activeIndex = index;

               // item.showqbhf=!item.showqbhf 

               // this.huifu=this.huifu

               // console.log(this.huifu)

            



       }, 
       //回复类别      
       qubuhf(){
            this.user=""; 
            this.getReplay(1)
       },
       ywxg(){
           this.user=window.sessionStorage.getItem("username")
           this.getReplay(1)
       },
       //分页
       pagechange:function(currentPage){
                 this.getReplay(currentPage);
       },
 
      },

       mounted(){
       },


      created(){
          this.getID();
          this.lookBlog();
          this. getReplay(1);
      }
}
</script>
<style lang="less" scoped>
.jz_middle{
   vertical-align:middle;
 }
 .span_close:hover{
       color:#3190e8;
 }
.content_log{
     margin:0 auto;
     width:1000px;
     height:500px;
     .log_img{
          width:515px;
          height:250px;
     }
}
.log_title{
     font-size:25px;
}
// .header_title{
//      margin-top:230px;
// }
.body_content{
     // height:500px;
     margin-top:80px;
     // overflow:auto;
}
.footer_author{
     margin-top:60px;
     float:right;
     margin-right:20px;
}
.image_content{
     display: flex;
}
.limg{
     width:200px;
     height:200px; 
}
.limg1{
     width:100px;
     height:100px; 
}
.limg2{
     width:70px;
     height:70px;  
}
.active_autoimg{
     position: absolute;
     overflow:auto;
}
.active_img{
     // left:50%;
     // top:50%;
     // margin-left:-300px;
     // margin-top:-300px;
     // width:600px;
     // height:600px;
     opacity: 1;
}
.activities_details{
     position:fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color:#262626;
        background:rgba(0, 0, 0, 0.5);
        z-index: 200;
}
.close_activities{
     position:absolute;
     bottom:10%;
     left:50%;
     transform: translateX(-50%);
}
.button_zi{
      text-shadow:#000 1px 0 0;
      border-radius: 5px;
      border:none;
      color:azure;
  }
  .heit{
    height:1.5rem;
  }
  .zhiding{
       background:#36d;
       border:none;
       color:white;
       padding:2px 12px;
       text-align:center;
       text-decoration:none;
       display:inline-block;
       font-size:16px;
       margin:4px 2px;
       cursor:pointer;
       border-radius: 5px;
  }
  .quxiaozd{
       background:#36d;
       border:none;
       color:#ed992c;
       padding:2px 12px;
       text-align:center;
       text-decoration:none;
       display:inline-block;
       font-size:16px;
       margin:4px 2px;
       cursor:pointer;
       border-radius: 5px;
  }
  .yulan_k{
       position: relative;
  }
  .zd_k{
       position: absolute;
       top:23px;
       left:222px; 
  }
  .hf_k{
       border:1px solid #ccc;
       margin-top:10px;
       padding:10px;
  }
  .xhf_c{
       margin-top:10px;
       padding:5px;
       background:#ecf2fc;
  }
  .xhf_p{
       margin-top:10px;
       padding:5px;
      background-image: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  }
  .hf_c_left{
       margin-top:20px;
      position: relative;
  }
    .hf_c_left1{
      position: relative;
  }
  .rname{
       position: absolute;
       top:50%;
       transform: translateY(-50%);
  }
  .fj_c{
       padding:10px;
       background:#ecf2fc;
  }

#green_channel #green_channel_digg {
    background-color: #2daebf;
}
#green_channel a:link, #green_channel a:visited, #green_channel a:active {
    color: #fff !important;
    border: none !important;
}
#green_channel a {
//     background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAAkCAYAAABIdFAMAAAAGXRFW…99ZOdcZGvt4mJjzMVKqcha68iIePB86GAiOv8CDADlIUQBs7MD3wAAAABJRU5ErkJggg%3D%3D) repeat-x;
    display: inline-block;
    padding: 3px 8px;
    color: #fff;
    text-decoration: none;
    font-weight: bold;
    cursor: pointer;
    margin-right: 10px;
    -moz-border-radius: 5px;
    -webkit-border-radius: 10px;
    -moz-box-shadow: 0 1px 3px rgba(0,0,0,.5);
    -webkit-box-shadow: 0 1px 3px rgba(0,0,0,.5);
    text-shadow: 0 -1px 1px rgba(0,0,0,.25);
    vertical-align: middle;
}
 

 .hf_content{
    width:150px;
    font-size: 10px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    background:#D7D7F1;
    border-radius: 5px; 
    position: absolute;
    top:-13px;
    left:200px;
    color:#fff;
    background-image: linear-gradient(to right, #D7D2DA 0%, #30433A 100%);
  
}

.ziti_t{
     width:50px;
     height:50px;
     background:#fff;
     border-radius: 50%;
     font-size:34px;
     margin-left:44px;
     margin-top:20px;
}
.qbhf_btn{
     background:#ff9812;
     color:#fff;
     border-radius: 5px;
     border:none;
     font-size:15px;
     height:30px;
}
.ywxg_btn{
     background:#ff455b;
     color:#fff;
     border-radius: 5px;
     border:none;
     height:30px;
     font-size:15px;
}
.qbhf_btn:focus,
.qbhf_btn:active:focus,
.qbhf_btn.active:focus,
.qbhf_btn.focus,
.qbhf_btn:active.focus,
.qbhf_btn.active.focus {
  outline: none;
  border-color: transparent; // 若是本身具有 border 请删除此属性
  box-shadow:none;
}
.ywxg_btn:focus,
.ywxg_btn:active:focus,
.ywxg_btn.active:focus,
.ywxg_btn.focus,
.ywxg_btn:active.focus,
.ywxg_btn.active.focus {
  outline: none;
  border-color: transparent; // 若是本身具有 border 请删除此属性
  box-shadow:none;
}
.name_f{
     font-size:15px;
     color:#000;
     font-weight:600;
}
.right_cp{
     margin-left:50px;
     font-size:15px;
     color:#000;
} 
.mg_n{
     margin-left:83px;
}
.qb_hf{
    background:#D7D7F1;
    border-radius: 5px;  
    font-size:15px;
    cursor:pointer;
    color:#fff!important;
    box-shadow: 0px 2px 6px 1px rgba(0, 0, 255, .2);
  
}
// .showqbhf{
//      display: none;
// }
.hf_show{
     -webkit-user-select:none;

   -moz-user-select:none;

   -ms-user-select:none;

   user-select:none;

   padding:3px;

  background-image: linear-gradient(to right, #D7D2D5 0%, #30434E 100%)
}

 
</style>

 


// WEBPACK FOOTER //
// src/pages/Forum/LookForum.vue